import { useState } from "react";
import type { Faq } from "@/mocks/faqs";

export default function FaqAccordion({ items }: { items: Faq[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <button
              type="button"
              aria-expanded={isOpen}
              onClick={() => setOpenIndex(isOpen ? null : index)}
              className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
            >
              <h3 className="font-heading text-base font-bold text-foreground-950">
                {item.q}
              </h3>
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                  isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                }`}
              >
                <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true" />
              </span>
            </button>
            {isOpen && (
              <div className="px-5 pb-5 pr-12">
                <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}